<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormDriedAbaloneCookingSheet
      :DriedAbaloneCookingSheet="editDriedAbaloneCookingSheet"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormDriedAbaloneCookingSheet from '../components/FormDriedAbaloneCookingSheet.vue';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormDriedAbaloneCookingSheet,
  },
  name: 'EditDriedAbaloneCookingSheet',
  module: 'DriedAbaloneCookingSheet',
  mixins: [loading, formatting, stockItem],
  data() {
    return {
      /**
      * Get/Set editing DriedAbaloneCookingSheet. Default to {}.
      */
      editDriedAbaloneCookingSheet: {},
      /**
       * Query Id for DriedAbaloneCookingSheet
       */
      driedAbaloneCookingSheetId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('driedAbaloneCookingSheets', ['driedAbaloneCookingSheets', 'driedAbaloneCookingSheet']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.driedAbaloneCookingSheetId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      this.editDriedAbaloneCookingSheet.stockItemId = item.id;
      this.editDriedAbaloneCookingSheet.farm = item.deliveryNote.farm.name;
      this.editDriedAbaloneCookingSheet.receivingDate = this.formatDate(
        item.deliveryNote.receivingDate,
      );
    });
    // eslint-disable-next-line max-len
    //   this.editDriedAbaloneCookingSheet.cookingDate = this.formatDate(dayjs(item.deliveryNote.receivingDate).add(2, 'day'));
    //   this.$log.info('Prepopulation completed');
    //   this.$forceUpdate();
    // });
    const { stockItemId } = this.$route.query;
    const summaries = await this.LOAD_driedAbaloneSummariesByStockItemId(stockItemId);
    if (summaries.length > 0) {
      this.editDriedAbaloneCookingSheet.farm = summaries[0].farm;
      this.editDriedAbaloneCookingSheet.drySizeRange = summaries[0].drySizeRange;
      this.editDriedAbaloneCookingSheet.cookingDate = summaries[0].cookingDate;
      this.editDriedAbaloneCookingSheet.deliveryDate = summaries[0].receivingDate;
      this.editDriedAbaloneCookingSheet.liveWeight = summaries[0].liveWeight;
    }
    console.debug(summaries);
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_driedAbaloneCookingSheet(this.driedAbaloneCookingSheetId);
      this.editDriedAbaloneCookingSheet = this.driedAbaloneCookingSheet;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('driedAbaloneCookingSheets', ['LOAD_driedAbaloneCookingSheet', 'CREATE_driedAbaloneCookingSheet', 'UPDATE_driedAbaloneCookingSheet']),
    ...mapActions('driedAbaloneSummaries', ['LOAD_driedAbaloneSummariesByStockItemId']),
    /** Method used to save the item
     */
    async save(driedAbaloneCookingSheet) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_driedAbaloneCookingSheet(driedAbaloneCookingSheet);
      } else {
        await this.UPDATE_driedAbaloneCookingSheet(driedAbaloneCookingSheet);
      }
      this.isSaving = false;
      this.$router.push({ name: 'dried-abalone-cooking-sheet-ListDriedAbaloneCookingSheet' });
    },
  },
};
</script>

<docs>
# EditDriedAbaloneCookingSheet example

'''js
<EditDriedAbaloneCookingSheet :DriedAbaloneCookingSheet="DriedAbaloneCookingSheet" />
'''
</docs>
